/**
 * Переиспользуемый селект размера страницы.
 * Дата: 17.03.2026 - Нужен для страниц со списками и таблицами.
 */
import { FilterSelect } from './FilterSelect';

export interface PageSizeSelectProps {
  value: number;
  onChange: (value: number) => void;
  options?: number[];
  disabled?: boolean;
  className?: string;
}

const DEFAULT_PAGE_SIZE_OPTIONS = [50, 100, 200, 500, 1000];

export function PageSizeSelect({
  value,
  onChange,
  options = DEFAULT_PAGE_SIZE_OPTIONS,
  disabled = false,
  className,
}: PageSizeSelectProps) {
  return (
    <div className={className}>
      <div className="mb-1 text-xs text-neutral-500">Показывать по</div>
      <FilterSelect
        value={String(value)}
        onChange={(next) => onChange(Number(next))}
        options={options.map((size) => ({ value: String(size), label: `${size}` }))}
        showAllOption={false}
        size="sm"
        disabled={disabled}
        aria-label="Размер страницы"
      />
    </div>
  );
}
